import React from "react";
import Popover from "@mui/material/Popover";
import clsx from "clsx";
import { isMobile } from "react-device-detect";
import { REACTION_EMOJIS } from "../../../constants/reaction-unicode";

const REACTION_OPTIONS = REACTION_EMOJIS;

const ReactionSheet = ({
    isOpen,
    onClose,
    onReactionSelect,
    userReactions = [],
    anchorEl
}) => (
    <Popover
        open={isOpen}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{
            vertical: 'top',
            horizontal: isMobile ? 'center' : 'left',
        }}
        transformOrigin={{
            vertical: 'bottom',
            horizontal: isMobile ? 'center' : 'left',
        }}
        PaperProps={{
            sx: {
                borderRadius: '500px',
                boxShadow: 3,
                px: 2,
                py: 1,
                minWidth: 220,
                minHeight: 56,
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                zIndex: 95,
            }
        }}
        disableScrollLock
        disablePortal
        container={() => anchorEl?.parentElement || document.body}
    >
        {REACTION_OPTIONS.map((reaction, index) => {
            const isSelected = userReactions.includes(reaction);
            return (
                <button
                    key={reaction}
                    onClick={() => {
                        onReactionSelect(reaction);
                        onClose();
                    }}
                    className={clsx(
                        "tw-flex tw-items-center tw-justify-center tw-w-10 tw-h-10 tw-rounded-full tw-text-xl tw-transition-all tw-duration-200 tw-transform active:tw-scale-95",
                        {
                            "tw-bg-purple-100 tw-text-purple-700": isSelected,
                            "tw-bg-white tw-text-gray-700 hover:tw-bg-gray-100": !isSelected,
                        }
                    )}
                    style={{ fontSize: 28, border: 'none', outline: 'none', cursor: 'pointer' }}
                    aria-pressed={isSelected}
                >
                    {reaction}
                </button>
            );
        })}
    </Popover>
);

export default ReactionSheet; 